import React from 'react'

import { RadioButton } from '../baseInputs'

type Props = {
  inputLabel?: string
}

const ContactPreferences = ({ inputLabel, ...rest }: Props) => {
  const label = inputLabel || `Contact Preferences`

  return (
    <div
      className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-2 md:gap-4 items-start justify-top mb-4 md:mb-2"
      data-gt-name="componentevent"
    >
      <div className="md:col-span-2 lg:col-span-1">
        <p className=" mt-5 mb-1 ">{label}</p>
        <p className="text-tiny mb-4">Please select your contact methods:</p>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div className="col-span-1">
            <div className="mb-4">
              <p className="">Phone </p>
            </div>
            <div className="radio-btn-container flex">
              <RadioButton
                errorDisabled
                name="contact_phone"
                label="Yes"
                value={true}
                {...rest}
              />
              <RadioButton
                errorDisabled
                name="contact_phone"
                label="No"
                value={false}
                {...rest}
              />
            </div>
          </div>
          <div className="col-span-1">
            <div className=" mb-4">
              <p className="">Email</p>
            </div>
            <div className="radio-btn-container flex">
              <RadioButton
                errorDisabled
                name="contact_email"
                label="Yes"
                value={true}
                {...rest}
              />
              <RadioButton
                errorDisabled
                name="contact_email"
                label="No"
                value={false}
                {...rest}
              />
            </div>
          </div>
          <div className="col-span-1">
            <div className=" mb-4">
              <p className=""> SMS</p>
            </div>
            <div className="radio-btn-container flex">
              <RadioButton
                errorDisabled
                name="contact_sms"
                label="Yes"
                value={true}
                {...rest}
              />
              <RadioButton
                errorDisabled
                name="contact_sms"
                label="No"
                value={false}
                {...rest}
              />
            </div>
          </div>
          <div className="col-span-1">
            <div className=" mb-4">
              <p className=""> Post</p>
            </div>
            <div className="radio-btn-container flex">
              <RadioButton
                errorDisabled
                name="contact_post"
                label="Yes"
                value={true}
                {...rest}
              />
              <RadioButton
                errorDisabled
                name="contact_post"
                label="No"
                value={false}
                {...rest}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ContactPreferences
